import * as T from '../types';

export default data => {
  return {
    type: T.CUSTOM_POPUP_OPEN,
    data,
  };
};
